function _typeof(obj) { "@babel/helpers - typeof"; if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") { _typeof = function _typeof(obj) { return typeof obj; }; } else { _typeof = function _typeof(obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }; } return _typeof(obj); }

function asyncGeneratorStep(gen, resolve, reject, _next, _throw, key, arg) { try { var info = gen[key](arg); var value = info.value; } catch (error) { reject(error); return; } if (info.done) { resolve(value); } else { Promise.resolve(value).then(_next, _throw); } }

function _asyncToGenerator(fn) { return function () { var self = this, args = arguments; return new Promise(function (resolve, reject) { var gen = fn.apply(self, args); function _next(value) { asyncGeneratorStep(gen, resolve, reject, _next, _throw, "next", value); } function _throw(err) { asyncGeneratorStep(gen, resolve, reject, _next, _throw, "throw", err); } _next(undefined); }); }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } }

function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); return Constructor; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function"); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, writable: true, configurable: true } }); if (superClass) _setPrototypeOf(subClass, superClass); }

function _setPrototypeOf(o, p) { _setPrototypeOf = Object.setPrototypeOf || function _setPrototypeOf(o, p) { o.__proto__ = p; return o; }; return _setPrototypeOf(o, p); }

function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function _createSuperInternal() { var Super = _getPrototypeOf(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = _getPrototypeOf(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return _possibleConstructorReturn(this, result); }; }

function _possibleConstructorReturn(self, call) { if (call && (_typeof(call) === "object" || typeof call === "function")) { return call; } else if (call !== void 0) { throw new TypeError("Derived constructors may only return object or undefined"); } return _assertThisInitialized(self); }

function _assertThisInitialized(self) { if (self === void 0) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return self; }

function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); return true; } catch (e) { return false; } }

function _getPrototypeOf(o) { _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf : function _getPrototypeOf(o) { return o.__proto__ || Object.getPrototypeOf(o); }; return _getPrototypeOf(o); }

import aqe from '../stores/aqe';
import * as CryptoJS from 'crypto-js';
import { AbstractEntityService } from './abstract-entity-service';
export var FileUploadService = /*#__PURE__*/function (_AbstractEntityServic) {
  _inherits(FileUploadService, _AbstractEntityServic);

  var _super = _createSuper(FileUploadService);

  function FileUploadService() {
    _classCallCheck(this, FileUploadService);

    return _super.apply(this, arguments);
  }

  _createClass(FileUploadService, [{
    key: "fetchRemoteSource",
    value: function () {
      var _fetchRemoteSource = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee(sourceURL) {
        var options,
            endpoint,
            _args = arguments;
        return regeneratorRuntime.wrap(function _callee$(_context) {
          while (1) {
            switch (_context.prev = _context.next) {
              case 0:
                options = _args.length > 1 && _args[1] !== undefined ? _args[1] : {};
                endpoint = new URL("".concat(FileUploadService.endpoint, "/fetch"));
                return _context.abrupt("return", this.execPost(endpoint.toString(), {
                  url: sourceURL
                }, options));

              case 3:
              case "end":
                return _context.stop();
            }
          }
        }, _callee, this);
      }));

      function fetchRemoteSource(_x) {
        return _fetchRemoteSource.apply(this, arguments);
      }

      return fetchRemoteSource;
    }()
  }, {
    key: "processFormDataUpload",
    value: function () {
      var _processFormDataUpload = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee2(fileType, ownerType, ownerId, fieldName, file, acl, meta, onProgress) {
        var endpoint, metadata;
        return regeneratorRuntime.wrap(function _callee2$(_context2) {
          while (1) {
            switch (_context2.prev = _context2.next) {
              case 0:
                // build endpoint
                endpoint = new URL(FileUploadService.endpoint);
                endpoint.searchParams.append('type', fileType);
                endpoint.searchParams.append('owner_type', ownerType);
                endpoint.searchParams.append('owner_id', ownerId.toString());
                endpoint.searchParams.append('acl', acl);

                if (meta !== null && meta !== void 0 && meta.tmpId) {
                  endpoint.searchParams.append('tmp_id', meta.tmpId);
                }

                if (!(fileType === 'image')) {
                  _context2.next = 16;
                  break;
                }

                if (meta !== null && meta !== void 0 && meta.progressive) {
                  endpoint.searchParams.append('progressive', 'true');
                }

                if (meta !== null && meta !== void 0 && meta.quality) {
                  endpoint.searchParams.append('quality', meta.quality.toString());
                }

                if (!(meta !== null && meta !== void 0 && meta.originalMediaUrl)) {
                  _context2.next = 16;
                  break;
                }

                _context2.t0 = meta.originalMediaUrl;
                _context2.next = 13;
                return FileUploadService.calculateFileHashFromBlob(file);

              case 13:
                _context2.t1 = _context2.sent;
                metadata = {
                  originalMediaUrl: _context2.t0,
                  hash: _context2.t1
                };
                endpoint.searchParams.append('metadata', JSON.stringify(metadata));

              case 16:
                return _context2.abrupt("return", new Promise(function (res, rej) {
                  // build request
                  var req = new XMLHttpRequest();
                  req.open('POST', endpoint.toString());
                  req.withCredentials = true;
                  req.upload.onprogress = onProgress;

                  req.onload = function () {
                    if (req.status >= 200 && req.status < 300) {
                      res({
                        url: req.responseText,
                        filename: file.name
                      });
                    } else {
                      rej(req);
                      console.warn('[FilePondClient] error', req.status, req);
                    }
                  }; // build form data


                  // build form data
                  var formData = new FormData();
                  formData.append(fieldName, file, file.name); // send req

                  // send req
                  req.send(formData);
                }));

              case 17:
              case "end":
                return _context2.stop();
            }
          }
        }, _callee2);
      }));

      function processFormDataUpload(_x2, _x3, _x4, _x5, _x6, _x7, _x8, _x9) {
        return _processFormDataUpload.apply(this, arguments);
      }

      return processFormDataUpload;
    }()
  }], [{
    key: "endpoint",
    get: function get() {
      return "".concat(aqe.defaults.publicApiDomain, "/media/uploads");
    }
  }, {
    key: "calculateFileHashFromBlob",
    value: function () {
      var _calculateFileHashFromBlob = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee3(blob) {
        var hash;
        return regeneratorRuntime.wrap(function _callee3$(_context3) {
          while (1) {
            switch (_context3.prev = _context3.next) {
              case 0:
                _context3.next = 2;
                return new Promise(function (res) {
                  var fileReader = new FileReader();

                  fileReader.onload = function (e) {
                    var data = CryptoJS.SHA256(CryptoJS.enc.Latin1.parse(e.target.result));
                    res(data);
                  };

                  fileReader.readAsBinaryString(blob);
                });

              case 2:
                hash = _context3.sent;
                return _context3.abrupt("return", hash.toString());

              case 4:
              case "end":
                return _context3.stop();
            }
          }
        }, _callee3);
      }));

      function calculateFileHashFromBlob(_x10) {
        return _calculateFileHashFromBlob.apply(this, arguments);
      }

      return calculateFileHashFromBlob;
    }()
  }]);

  return FileUploadService;
}(AbstractEntityService);